(function() {
  $('.rc-subscription-details .rc-subscription-details__button .reload-icon').attr({"role": "none", "focusable":"false"});
})();

function liveAnnouncement(liveText, waiting = 1000) {
    const para = document.createElement("p");
    para.innerText = liveText;
    document.getElementById('live-ann').appendChild(para);
    setTimeout(function() {
        document.getElementById('live-ann').innerHTML = "";
    }, waiting);
}

window.addEventListener("DOMContentLoaded", function() {
    console.log("A11y_Start");
  $('.rc-subscription-details .rc-subscription-details__button .reload-icon').attr({"role": "none", "focusable":"false"});
    setTimeout(function() {
        $('.post-link > h3 > a').removeAttr('tabindex');
        $('.post-link > h3 > a').removeAttr('href');

        console.log("Timeout");
    }, 2000);

    $('.TestimonialNav .TestimonialNav__Item ').keydown(function(event) {

        if (event.which == "13") {
            $(this).click();
        }
    });

    $('button.Search__Close.Link.Link--primary').click(function() {
        setTimeout(function() {
            $('.Header__Icon.Icon-Wrapper--clickable.a11y_focus').focus();
        }, 100);

    });

    setTimeout(function() {
        $('.Slideshow__Carousel.Carousel.Carousel--fadeIn.Carousel--fixed.Carousel--insideDots.flickity-enabled').removeAttr('tabindex');
        $('.ProductList.ProductList--carousel.Carousel.flickity-enabled').removeAttr('tabindex');
        $('.ProductListWrapper  .ProductList.ProductList--carousel.Carousel.flickity-enabled.is-draggable').removeAttr('tabindex');
        $('.slick-list .slick-track .Grid__Cell').removeAttr('tabindex');
        $('.slick-list .slick-track >div').removeAttr('aria-describedby');
        $('.slick-list .slick-track >div').removeAttr('tabindex');
        $('.TestimonialList.TestimonialList--withNav').removeAttr('tabindex');
    }, 2000);
    $('.slick-list .slick-track .mt-4.slick-slide').removeAttr('tabindex');

    $('.rc-subscription-details__button.p-0').keydown(function(event) {
        if (event.which == "27") {
            $(this).next().hide();
        }
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === "Escape") {
            document.body.style.pointerEvents = 'none';
            document.body.style.zIndex = '-1';
        }
    });

    document.addEventListener('mousemove', function(event) {
        document.body.style.pointerEvents = 'auto';
        document.body.style.zIndex = '0';
    });

    $('.SectionHeader__TabList.TabList button').attr('aria-selected', 'false');
    $('.SectionHeader__TabList.TabList button.is-active').attr('aria-selected', 'true');
    $('.SectionHeader__TabList.TabList button').click(function() {
        $('.SectionHeader__TabList.TabList button').attr('aria-selected', 'false');
        var state = $(this).hasClass('.is-active');
        if (state == true) {
            $(this).attr('aria-selected', 'false');
        } else {
            $(this).attr('aria-selected', 'true');
        }
    });


    // $( document ).ready(function() {
    // $('.spr-summary-actions-newreview').attr({'role':'button','aria-expanded':'false'});
    //   $('.spr-summary-actions-newreview').click(function(){

    //   var state = $(this).attr('aria-expanded');
    //   if(state == "true"){
    //       $(this).attr('aria-expanded','false');
    //   }
    //   else{
    //       $(this).attr('aria-expanded','true');
    //   }
    //   });
    //       console.log( "document loaded" );
    //   });

    $("#mobile-menu-sidebar").click(function() {
        setTimeout(function() {
            $("#sidebar-close-button").focus();
            $("#shopify-section-sidebar-menu").siblings().attr("aria-hidden", "true");
        }, 250);
    });

    $("#sidebar-close-button").click(function() {
        setTimeout(function() {
            $("#shopify-section-sidebar-menu").siblings().removeAttr("aria-hidden");
            $("#mobile-menu-sidebar").focus();
        }, 250);
    });


    $("#open-cart-drawer, #open-cart-drawer-1").click(function() {
        setTimeout(function() {
            $("#cart-drawer-close-button").focus();
            $("#sidebar-cart").siblings().attr("aria-hidden", "true");
        }, 500);
    });

    $("#cart-drawer-close-button").click(function() {
        setTimeout(function() {
            $("#sidebar-cart").siblings().removeAttr("aria-hidden");
            $("#open-cart-drawer:visible, #open-cart-drawer-1:visible").focus();
        }, 500);
    });

    $("ol.flickity-page-dots").each(function() {
        $(this).attr("role", "group");
        $(this).find('> li.dot').each(function() {
            $(this).attr({
                "tabindex": "0",
                "aria-label": "Slide " + ($(this).index() + 1),
                "role": "button"
            });
        });
    });

    $('.ProductItem__Wrapper > a+div .ProductItem__Title >a, .featured-video > a').focus(function() {
        $(this).parent().addClass("highlight-indicator");
    });

    $('.ProductItem__Wrapper > a+div .ProductItem__Title >a, .featured-video > a').blur(function() {
        $(this).parent().removeClass("highlight-indicator");
    });

    $(".DropdownMenu ul > li > a").keydown(function() {
        if (event.key == 'Escape') {
            $(this).closest('li.HorizontalList__Item').find('> a').focus();
            $(this).closest('li.HorizontalList__Item').removeClass('is-expanded');
        }
    });

    $('.HorizontalList li[aria-haspopup]').focusin(function() {
        $(this).find("> a").attr("aria-expanded", true);
        console.log("focus in")
    });

    $('.HorizontalList li[aria-haspopup]').focusout(function() {
        $(this).find("> a").removeAttr("aria-expanded");
        console.log("focus out")
    });

    setTimeout(function() {
        $(".Carousel").removeAttr("tabindex");
    }, 1000);

    setTimeout(function() {
        $(".recharge-badge span+svg").attr({
            "role": "img",
            "aria-label": "recharge"
        });
        
    }, 2000);

    $('.Popover__ValueList > button.Popover__Value').click(function() {
        liveAnnouncement("Products sorted, " + $(this).text().trim());
    });
  
  $('.jl-sample > img').attr("alt", "");

  $(document).on("focus",'[name="review[body]"]', function() {
    $('.spr-form-review-body span[aria-atomic]').attr('role',"status").attr('aria-live', 'polite');
  });
  $(document).on("blur",'[name="review[body]"]', function() {
    $('.spr-form-review-body span[aria-atomic]').removeAttr('role').removeAttr('aria-live');
  });

  $(document).on("click",".spr-summary-actions-newreview", function() {
    $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "false");
  });

  $('.Product__SlideshowNav.Product__SlideshowNav--thumbnails > div > a.is-selected').attr('aria-current', true);

  $('.Product__SlideshowNav.Product__SlideshowNav--thumbnails > div > a').click(function() {
    liveAnnouncement("Selected, "+$(this).find('img').attr('alt'), 3000);
    $('.Product__SlideshowNav.Product__SlideshowNav--thumbnails > div > a').removeAttr('aria-current');
    $(this).attr('aria-current', true);
  });

    console.log("A11y_End");
});